<template>
    <div>
        <file-pond
            ref="pond"
            :required="!!required"
            :files="this.files"
            :name="this.name"
            :server="this.server"
            :allowMultiple="false"
            :allowReplace="true"
            :acceptedFileTypes="this.acceptedFileTypes"
            :allowFileTypeValidation="this.allowFileTypeValidation"
            maxFileSize="2MB"
            credits="false"
            label-idle=""
            v-bind="{labelInvalidField: this.$t('upload.labelInvalidField'),
labelFileWaitingForSize: this.$t('upload.labelFileWaitingForSize'),
labelFileSizeNotAvailable: this.$t('upload.labelFileSizeNotAvailable'),
labelFileLoading: this.$t('upload.labelFileLoading'),
labelFileLoadError: this.$t('upload.labelFileLoadError'),
labelFileProcessing: this.$t('upload.labelFileProcessing'),
labelFileProcessingComplete: this.$t('upload.labelFileProcessingComplete'),
labelFileProcessingAborted: this.$t('upload.labelFileProcessingAborted'),
labelFileProcessingError: this.$t('upload.labelFileProcessingError'),
labelFileProcessingRevertError: this.$t('upload.labelFileProcessingRevertError'),
labelFileRemoveError: this.$t('upload.labelFileRemoveError'),
labelTapToCancel: this.$t('upload.labelTapToCancel'),
labelTapToRetry: this.$t('upload.labelTapToRetry'),
labelTapToUndo: this.$t('upload.labelTapToUndo'),
labelButtonRemoveItem: this.$t('upload.labelButtonRemoveItem'),
labelButtonAbortItemLoad: this.$t('upload.labelButtonAbortItemLoad'),
labelButtonRetryItemLoad: this.$t('upload.labelButtonRetryItemLoad'),
labelButtonAbortItemProcessing: this.$t('upload.labelButtonAbortItemProcessing'),
labelButtonUndoItemProcessing: this.$t('upload.labelButtonUndoItemProcessing'),
labelButtonRetryItemProcessing: this.$t('upload.labelButtonRetryItemProcessing'),
labelButtonProcessItem: this.$t('upload.labelButtonProcessItem'),
labelMaxFileSizeExceeded: this.$t('upload.labelMaxFileSizeExceeded'),
labelMaxFileSize: this.$t('upload.labelMaxFileSize'),
labelMaxTotalFileSizeExceeded: this.$t('upload.labelMaxTotalFileSizeExceeded'),
labelMaxTotalFileSize: this.$t('upload.labelMaxTotalFileSize'),
labelFileTypeNotAllowed: this.$t('upload.labelFileTypeNotAllowed'),
fileValidateTypeLabelExpectedTypes: this.$t('upload.fileValidateTypeLabelExpectedTypes'),
}"
        />

        <div class="mt-4">
            <button class="flex items-center text-red font-semibold text-sm"
                    type="button"
                    @click.prevent="browse"
            >
                <upload-icon class="w-6 mr-2"/>
                {{ label }}
            </button>
        </div>
    </div>
</template>
<script>
import UploadIcon from './icons/Upload';
import FilePond from '../filepond';

export default {
    components: {
        FilePond,
        UploadIcon
    },
    props: {
        required: {
            default: false,
        },
        value: {
            type: Array,
            required: false,
            default: () => { return []; }
        },
        name: {
            type: String,
            required: true
        },
        baseUrl: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        processUrl: {
            type: String,
            required: true
        },
        revertUrl: {
            type: String,
            required: true,
        },
        csrf: {
            type: String,
            required: true
        },
        acceptedFileTypes: {
            type: Array,
            required: true,
        },
        allowFileTypeValidation: {
            type: Boolean,
            required: false,
        }
    },
    data() {
        return {
            server: {
                process: this.processUrl,
                revert: this.revertUrl,
                load: this.restoreUrl(),
                headers: {'X-CSRF-Token': this.csrf}
            },
            files: this.getFiles(),
        }
    },
    methods: {
        restoreUrl() {
            let baseUrl = this.baseUrl.replace(/\/$/, "");

            return `${baseUrl}/files/`;
        },
        browse() {
            this.$refs.pond.browse()
        },
        getFiles() {
            return this.value.map((fileUuid) => {
                return {
                    // ensure file uuid is a string
                    source: '' + fileUuid,
                    options: {
                        type: 'local'
                    }
                };
            });
        }
    }
}
</script>
